module.exports = __webpack_public_path__ + "img/easy-crock-pot-refried-beans.733ecbec.jpg";